import { createRoot } from 'react-dom/client';
import App from './app';

const container = document.getElementById('root');

const root = createRoot(container);


console.time('[React Render]');
root.render(<App />);
setTimeout(() => console.timeEnd('[React Render]'), 0);